export class UserGroupAssignmentRequestDTO {
  userId: string;
  groupId: string;
  permissionIds: string[];
}
